import type { Resource } from '../../';
export const forms_error_phoneNumber_tooLong: Resource = {"default":"The phone number is too long."};
